var _defs, _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a,.b{fill:none;}\n      .b{opacity:0.305;}\n      .c{fill:#014386;}\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 26,
    height: 26
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 26,
    height: 26
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.5 6.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 13,
    height: 13,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.32 0.783)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M.7,0A.7.7,0,0,0,.2.207a.711.711,0,0,0,0,1L4.546,5.715.2,10.228a.71.71,0,0,0,0,.994.715.715,0,0,0,.995,0l4.96-5.01a.711.711,0,0,0,0-1L1.2.207A.7.7,0,0,0,.7,0Z",
    transform: "translate(0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRight);
export default __webpack_public_path__ + "static/media/ic_arrow_right.9c0745c15c201af164bf6933d062fa19.svg";
export { ForwardRef as ReactComponent };